import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ParamHashGuard {
  /**
   * Determines if the route page should be loaded based on hash parameter.
   * Verifies that a hash parameter exists in the URL query parameters.
   *
   * @param {ActivatedRouteSnapshot} route The activated route snapshot
   * @returns {boolean} true if the hash parameter is present, false otherwise
   */
  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const hash = route.queryParams['hash'];

    if (hash) {
      return true;
    }

    window.location.href = environment.siteUrls.tests;

    return false;
  }
}
